import { IGetVillageListRequestSchema } from '../../../node/repositories/countryside-search/entities/schemas/GetVillageListRequestSchema';
import { Action } from './actions';

export function lastFiltersReducer(
  state: IGetVillageListRequestSchema | null = null,
  action: Action,
): IGetVillageListRequestSchema | null {
  switch (action.type) {
    case 'ISaveLastFilters':
      return action.filters;
    case 'IClearLastFilters':
      return null;
    default:
      return state;
  }
}
